import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createAccessPoint } from 'store/actions/accessPoints/createAccessPoint';
import AccessPointCreateForm from './AccessPointCreateForm';
import Breadcrumbs, { generateBreadcrumbsFromPath } from 'components/layout/Layout/Breadcrumbs';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';
import Section from 'components/ui/general/Section';
import Column from 'components/ui/show/Column';
import InnerColumn from 'components/ui/show/InnerColumn';
import { fetchProduct } from 'store/actions/products/fetchProducts';
import utils from 'helpers/utils';

class AccessPointCreateContainer extends Component {
    constructor(props) {
        super(props);

        const initialValues = {
            type: 'access',
        };

        const { productId } = props;

        if (productId) {
            initialValues.product_id = productId;
        }

        this.state = {
            initialValues: initialValues,
        };
    }

    componentDidMount() {
        if (this.props.productId) {
            const { fetchAccessPointProduct, productId } = this.props;

            fetchAccessPointProduct(productId);
        }
    }

    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            productId,
        } = this.props;

        return new Promise((resolve) => {
            return dispatchForm({
                onError: resolve,
                onSuccess: () => {
                    if (productId) {
                        resolve(history.push(`/products/${ productId }/show`));
                    } else {
                        resolve(history.push('/access-points/'));
                    }
                },
                values: values,
            });
        });
    }

    render() {
        const {
            history,
            location,
            product,
            resource,
            translate,
        } = this.props;

        const breadcrumbs = [];

        if (utils.isEmpty(product)) {
            breadcrumbs.push(
                {
                    label: translate('resources.access_points.title'),
                    link: `/${ resource }`,
                },
                {
                    label: translate('actions.create'),
                }
            );
        } else {
            breadcrumbs.push(
                ...generateBreadcrumbsFromPath({
                    products: translate('resources.products.title'),
                    [product.id]: product,
                    'access-point': translate('resources.access_points.title'),
                }, this.props)
            );
        }

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs }/>

                <Header>
                    <Title title={ translate('resources.access_points.actions.create.title') } />
                </Header>

                <Section>
                    <Column>
                        <InnerColumn>
                            <AccessPointCreateForm
                                initialValues={ this.state.initialValues }
                                form='access-point-create'
                                handleSubmitForm={ this.handleSubmitForm }
                                history={ history }
                                location={ location }
                            />
                        </InnerColumn>
                    </Column>
                </Section>
            </div>
        );
    }
}

AccessPointCreateContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    fetchAccessPointProduct: PropTypes.func,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    productId: PropTypes.string,
    product: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    return {
        product: props.productId ? state.products.data[props.productId] : null,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (payload) => {
            dispatch(createAccessPoint(payload));
        },
        fetchAccessPointProduct: (id) => {
            dispatch(fetchProduct({
                id: id,
            }));
        },
    };
};

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    translate,
);

export default enhance(AccessPointCreateContainer);


// WEBPACK FOOTER //
// ./src/pages/accessPoints/create/AccessPointCreateContainer.js